/**
 * Used to transform some zip codes to city districts.
 */
class ZipCodeFormatter {
  static config = [
    [ /^750(?<district>0[1-9]|1[0-9]|20)$/, 'Paris %' ],
    [ /^130(?<district>0[1-9]|1[0-6])$/, 'Marseille %' ],
    [ /^690(?<district>0[1-9])$/, 'Lyon %' ],
  ];

  static beautify(code) {
    // eslint-disable-next-line no-restricted-syntax
    for (const c of ZipCodeFormatter.config) {
      const parts = c[0].exec(code);
      if (parts) {
        return c[1].replace('%', parts.groups.district);
      }
    }
    return code;
  }
}

export function beautify(code) {
  return ZipCodeFormatter.beautify(code);
}
